<template>
  <el-collapse-item name="github">
    <template #title>
      <div>
        <div class="el-collapse-item__image">
          <img src="./img/github.svg" >
        </div>
        <span class="el-collapse-item__title">GitHub</span>
        <span class="el-collapse-item__sub-title">Build software better, together</span>
      </div>
    </template>
    <div>
      <h4>Update {{itemNamePlural}} through Git commits</h4>
      <p>When you push commits to a Github repository, you can also add comments, update the assignee (or unassign) and the status of {{ itemNamePlural }} in 
        {{ entityName }}. Read our
        <a
          target="_blank"
          href="https://www.donedone.com/help-docs/integrating-a-github-repository-to-a-donedone-project"
          class="just-a-link"
        >Github syntax guide</a> to see how simple it is to structure your commit messages.
      </p>
      <p><br ></p>
      <p>
        <strong>Note:</strong> A user's Github email address is used to associate commits to the person with the same email address in DoneDone.
      </p>
      <p><br ></p>
      <ol>
        <li>
          Visit your Github repository and choose the <strong>Settings</strong> tab.
        </li>
        <li>
          On the Settings page, click <strong>Webhooks</strong>.
        </li>
        <li>
          Click the <strong>Add webhook</strong> button and enter the information below.
          <p><br></p>
          <div v-for="item in githubIntegration" :key="item.value">
            <strong>{{ item.name }}</strong>
            <pre>{{ item.value }}</pre>
          </div>
          <p><br></p>
        </li>
        <li>Make sure the webhook is set to <strong>Active</strong>, then click <strong>Update webhook</strong>. You're all set!
        </li></ol>
    </div>
  </el-collapse-item>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'
import { INameAndValue } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'GithubIntegrationAccordion',

  props: {
    type: {
      type: String as () => EEntities,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    entityName: {
      type: String,
      required: true,
    },
    githubIntegration: {
      type: Array as () => INameAndValue[],
      required: true,
    },
  },

  computed: {
    itemName(): string {
      return TextAssistant.itemSingularName(this.type).toLowerCase()
    },
    itemNamePlural(): string {
      return TextAssistant.itemPluralName(this.type).toLowerCase()
    },
  },
})
</script>
